var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEmptyDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "-26.775%",
    x2: "-7.069%",
    y2: "-26.775%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.15,
    offset: "61.804%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    y2: "50%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.15,
    offset: "43.835%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    y2: "50%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.15,
    offset: "43.835%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4C1CE",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 42.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    fillOpacity: 0.2,
    fill: "#62EAA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 116a4 4 0 1 1-8 0 4 4 0 0 1 8 0M49 61a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    fillOpacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 49.5c0 1.38-1.344 2.5-3 2.5s-3-1.12-3-2.5 1.344-2.5 3-2.5 3 1.12 3 2.5m122-21c0 1.38-1.344 2.5-3 2.5s-3-1.12-3-2.5 1.344-2.5 3-2.5 3 1.12 3 2.5",
    fillOpacity: 0.2,
    fill: "#2EF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 72c0 1.104-1.344 2-3 2s-3-.896-3-2 1.344-2 3-2 3 .896 3 2",
    fillOpacity: 0.2,
    fill: "#62EAA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 15.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    fillOpacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.62 94.917c-1.402-.045-2.524-1.108-2.524-2.417 0-1.308 1.122-2.372 2.523-2.418h.876c1.808 0 3.287-1.368 3.287-3.04 0-1.674-1.48-3.042-3.287-3.042H10.287C8.478 84 7 85.368 7 87.041c0 1.673 1.478 3.041 3.287 3.041H43.25c1.402.046 2.524 1.11 2.524 2.418 0 1.309-1.122 2.372-2.525 2.417H29.98c-1.808 0-3.287 1.369-3.287 3.041 0 1.673 1.479 3.042 3.287 3.042h39.733C71.522 101 73 99.631 73 97.958c0-1.672-1.478-3.041-3.287-3.041H59.62z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.376 137C76.07 137 75 135.969 75 134.709V33.29c0-1.258 1.07-2.29 2.376-2.29h76.248c1.307 0 2.376 1.032 2.376 2.291V134.71c0 1.26-1.07 2.291-2.376 2.291H77.376z",
    fillOpacity: 0.1,
    fill: "#40FFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.738 40c-1.698 0-3.086 1.45-3.086 3.22 0 1.771 1.388 3.221 3.086 3.221h.822c1.317.048 2.372 1.173 2.372 2.56 0 1.384-1.055 2.51-2.372 2.558H167V58h27.639c1.697 0 3.086-1.45 3.086-3.22 0-1.771-1.389-3.221-3.086-3.221h-3.898c-1.317-.048-2.372-1.174-2.372-2.559 0-1.386 1.054-2.511 2.371-2.559h30.174c1.697 0 3.086-1.45 3.086-3.221 0-1.77-1.389-3.22-3.086-3.22h-44.176z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.148 88c-1.071 0-1.948 1.047-1.948 2.325 0 1.28.877 2.327 1.948 2.327h.52c.83.034 1.497.847 1.497 1.848 0 1-.666 1.814-1.498 1.848H196V101h17.45c1.072 0 1.95-1.047 1.95-2.326 0-1.279-.878-2.326-1.95-2.326h-2.46c-.832-.034-1.498-.848-1.498-1.848s.666-1.814 1.497-1.848h11.062c1.072 0 1.949-1.047 1.949-2.327 0-1.278-.877-2.325-1.949-2.325h-19.903z",
    fill: "url(#c)",
    transform: "matrix(1 0 0 -1 0 189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.485 86c-2.789 0-5.614.73-8.16 2.257-7.271 4.369-9.506 13.617-4.992 20.653 2.934 4.574 7.999 7.09 13.181 7.09 2.79 0 5.616-.73 8.16-2.258 7.271-4.368 9.508-13.616 4.993-20.652-2.935-4.575-8-7.09-13.182-7.09m.001 2.727c4.425 0 8.456 2.168 10.787 5.801 3.686 5.75 1.854 13.327-4.085 16.897a12.967 12.967 0 0 1-6.674 1.848c-4.424 0-8.457-2.17-10.786-5.801-1.787-2.785-2.347-6.077-1.574-9.267.77-3.193 2.781-5.9 5.659-7.631a12.972 12.972 0 0 1 6.673-1.847",
    fillOpacity: 0.8,
    fill: "#62EAA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.294 130.535c-1.689.902-3.93.452-4.979-1.004l-7.774-10.78c-1.049-1.454-.525-3.383 1.164-4.285 1.69-.904 3.93-.452 4.979 1.002l7.775 10.78c1.05 1.456.525 3.384-1.165 4.287",
    fillOpacity: 0.5,
    fill: "#2EF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#62EAA3",
    strokeWidth: 3,
    opacity: 0.8,
    d: "M129.25 52v12.571m10-16.571v16.622m-5-5.622v5.714M108 49H93v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 77V33.954A2.961 2.961 0 0 0 155.05 31h-77.1A2.961 2.961 0 0 0 75 33.954v93.655c0 5.27 2.543 8.391 6.886 8.391h73.828s2.977-.882 5.237-5.576c1.352-2.805 1.01-5.476 1.01-6.237H93.304S94.848 136 81.886 136",
    stroke: "#62EAA3",
    strokeWidth: 3,
    opacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40FFFA",
    strokeWidth: 3,
    opacity: 0.5,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    d: "M93 81h48M93 93h48m-48 12h25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40FFFA",
    strokeWidth: 3,
    opacity: 0.5,
    d: "M107.969 49H117v14H93v-7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyDark);
export default __webpack_public_path__ + "static/media/ic-empty-dark.b9962d6493862cdcc7693a60f22669d9.svg";
export { ForwardRef as ReactComponent };